import { render, staticRenderFns } from "./paymentStatus.vue?vue&type=template&id=d89a2f62&scoped=true"
import script from "./paymentStatus.vue?vue&type=script&lang=js"
export * from "./paymentStatus.vue?vue&type=script&lang=js"
import style0 from "./paymentStatus.vue?vue&type=style&index=0&id=d89a2f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a2f62",
  null
  
)

export default component.exports